import React, { useState } from "react";
import { Space, Typography } from "antd";
import { TimePicker } from "../../components/antOverrides";
import moment from "moment";
const { Text } = Typography;

const TimeRangePicker = (props) => {
  const {
    onStartChange,
    onEndChange,
    startValue,
    endValue,
    startText,
    endText,
    endOnNextDay,
    ...rest
  } = props;
  const [endOpen, setEndOpen] = useState(false);
  const disabledStartHours = () => {
    if (endOnNextDay || !endValue) return [];
    var hours = [];
    for (var i = 23; i > moment(endValue).get("hour"); i--) {
      hours.push(i);
    }
    return hours;
  };

  const disabledStartMinutes = (selectedHour) => {
    if (endOnNextDay || !endValue) return [];
    const endHour = moment(endValue).get("hour");
    const endMinutes = moment(endValue).get("minute");
    var minutes = [];
    if (selectedHour === endHour) {
      for (var i = 59; i > endMinutes; i--) {
        minutes.push(i);
      }
    }
    return minutes;
  };

  const disabledEndHours = () => {
    if (!startValue || endOnNextDay) return [];
    var hours = [];
    for (var i = 0; i < moment(startValue).get("hour"); i++) {
      hours.push(i);
    }
    return hours;
  };

  const disabledEndMinutes = (selectedHour) => {
    if (!startValue || endOnNextDay) return [];
    const startHour = moment(startValue).get("hour");
    const startMinutes = moment(startValue).get("minute");
    var minutes = [];
    if (selectedHour === startHour) {
      for (var i = 0; i < startMinutes; i++) {
        minutes.push(i);
      }
    }
    return minutes;
  };

  const disabledStartTime = () => ({
    disabledHours: () => disabledStartHours(),
    disabledMinutes: (selectedHour) => disabledStartMinutes(selectedHour),
  });

  const disabledEndTime = () => ({
    disabledHours: () => disabledEndHours(),
    disabledMinutes: (selectedHour) => disabledEndMinutes(selectedHour),
  });

  const handleEndOpenChange = (open) => {
    setEndOpen(open);
    if (open && !endValue && startValue) {
      onEndChange(startValue.clone().add(1, "hour"));
    }
  };

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <Space size="middle">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Text type="secondary">{startText}</Text>
          <TimePicker
            style={{ width: "130px" }}
            {...rest}
            onChange={onStartChange}
            value={startValue}
            disabledTime={disabledStartTime}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Text type="secondary">{endText}</Text>
          <TimePicker
            style={{ width: "130px" }}
            {...rest}
            onChange={onEndChange}
            value={endValue}
            disabledTime={disabledEndTime}
            onOpenChange={handleEndOpenChange}
          />
        </div>
      </Space>
    </div>
  );
};

export default TimeRangePicker;
